import { FREE_SIGNUP_CREDITS } from '../../config/en/credits'
import i18n from '../../i18n'

export function getDesignersSeo() {
  return {
    title: i18n.t('landingDesigners.seo.title'),
    description: i18n.t('landingDesigners.seo.description'),
    path: '/designers',
  }
}

export function getDesignersNav() {
  return [
    { href: '#benefits', label: i18n.t('landingDesigners.nav.forWhom') },
    { href: '#tools', label: i18n.t('landingDesigners.nav.tools') },
    { href: '#how', label: i18n.t('landingDesigners.nav.howToConnect') },
    { href: '#contact', label: i18n.t('landingDesigners.nav.application') },
  ] as const
}

export function getDesignersHero() {
  return {
    badge: i18n.t('landingDesigners.hero.badge'),
    titleAccent: i18n.t('landingDesigners.hero.titleAccent'),
    titleRest: i18n.t('landingDesigners.hero.titleRest'),
    subtitle: i18n.t('landingDesigners.hero.subtitle'),
    trialBadge: i18n.t('landingDesigners.hero.trialBadge', { credits: FREE_SIGNUP_CREDITS }),
    primaryCta: i18n.t('landingDesigners.hero.primaryCta'),
    secondaryCta: i18n.t('landingDesigners.hero.secondaryCta'),
    previewSub: i18n.t('landingDesigners.hero.previewSub'),
    previewPrompt: i18n.t('landingDesigners.hero.previewPrompt'),
  }
}

export function getDesignersAudience() {
  return [
    {
      title: i18n.t('landingDesigners.audience.freelance.title'),
      desc: i18n.t('landingDesigners.audience.freelance.desc'),
    },
    {
      title: i18n.t('landingDesigners.audience.studio.title'),
      desc: i18n.t('landingDesigners.audience.studio.desc'),
    },
    {
      title: i18n.t('landingDesigners.audience.inhouse.title'),
      desc: i18n.t('landingDesigners.audience.inhouse.desc'),
    },
  ] as const
}

export function getDesignersWholesale() {
  return [
    {
      title: i18n.t('landingDesigners.wholesale.credits.title'),
      desc: i18n.t('landingDesigners.wholesale.credits.desc'),
    },
    {
      title: i18n.t('landingDesigners.wholesale.manager.title'),
      desc: i18n.t('landingDesigners.wholesale.manager.desc'),
    },
    {
      title: i18n.t('landingDesigners.wholesale.training.title'),
      desc: i18n.t('landingDesigners.wholesale.training.desc'),
    },
    {
      title: i18n.t('landingDesigners.wholesale.support.title'),
      desc: i18n.t('landingDesigners.wholesale.support.desc'),
    },
  ] as const
}

export function getDesignersFeatures() {
  return [
    {
      title: i18n.t('landingDesigners.tools.images.title'),
      desc: i18n.t('landingDesigners.tools.images.desc'),
    },
    {
      title: i18n.t('landingDesigners.tools.i2i.title'),
      desc: i18n.t('landingDesigners.tools.i2i.desc'),
    },
    {
      title: i18n.t('landingDesigners.tools.illustration.title'),
      desc: i18n.t('landingDesigners.tools.illustration.desc'),
    },
    {
      title: i18n.t('landingDesigners.tools.infographics.title'),
      desc: i18n.t('landingDesigners.tools.infographics.desc'),
    },
  ] as const
}

export function getDesignersExamples() {
  return [
    {
      title: i18n.t('landingDesigners.examples.packaging.title'),
      desc: i18n.t('landingDesigners.examples.packaging.desc'),
    },
    {
      title: i18n.t('landingDesigners.examples.referenceEdit.title'),
      desc: i18n.t('landingDesigners.examples.referenceEdit.desc'),
    },
    {
      title: i18n.t('landingDesigners.examples.brandIllustration.title'),
      desc: i18n.t('landingDesigners.examples.brandIllustration.desc'),
    },
    {
      title: i18n.t('landingDesigners.examples.infographics.title'),
      desc: i18n.t('landingDesigners.examples.infographics.desc'),
    },
    {
      title: i18n.t('landingDesigners.examples.mockup.title'),
      desc: i18n.t('landingDesigners.examples.mockup.desc'),
    },
    {
      title: i18n.t('landingDesigners.examples.campaign.title'),
      desc: i18n.t('landingDesigners.examples.campaign.desc'),
    },
  ] as const
}

export function getDesignersSteps() {
  return [
    {
      step: '1',
      title: i18n.t('landingDesigners.steps.step1.title'),
      desc: i18n.t('landingDesigners.steps.step1.desc'),
    },
    {
      step: '2',
      title: i18n.t('landingDesigners.steps.step2.title'),
      desc: i18n.t('landingDesigners.steps.step2.desc'),
    },
    {
      step: '3',
      title: i18n.t('landingDesigners.steps.step3.title'),
      desc: i18n.t('landingDesigners.steps.step3.desc'),
    },
  ] as const
}

export function getDesignersContact() {
  return {
    title: i18n.t('landingDesigners.contact.title'),
    bullets: [
      i18n.t('landingDesigners.contact.bullet1'),
      i18n.t('landingDesigners.contact.bullet2'),
      i18n.t('landingDesigners.contact.bullet3'),
      i18n.t('landingDesigners.contact.bullet4'),
    ],
    formSuccess: i18n.t('landingDesigners.contact.formSuccess'),
    mailSubject: i18n.t('landingDesigners.contact.mailSubject'),
  }
}

export function getDesignersFinalCta() {
  return {
    title: i18n.t('landingDesigners.finalCta.title'),
    desc: i18n.t('landingDesigners.finalCta.desc'),
    button: i18n.t('landingDesigners.finalCta.button'),
  }
}

export function getDesignersLogosStrip() {
  return i18n.t('landingDesigners.logosStrip')
}

export function getDesignersLeadTypes() {
  return [
    { value: 'freelance', label: i18n.t('landingDesigners.leadTypes.freelance') },
    { value: 'studio', label: i18n.t('landingDesigners.leadTypes.studio') },
    { value: 'inhouse', label: i18n.t('landingDesigners.leadTypes.inhouse') },
  ] as const
}

export function buildDesignersLeadBody(params: {
  name: string
  contact: string
  typeLabel: string
  comment?: string
}) {
  return [
    i18n.t('landingDesigners.contact.formBodyHeader'),
    '',
    i18n.t('landingDesigners.contact.formBodyName', { name: params.name }),
    i18n.t('landingDesigners.contact.formBodyContact', { contact: params.contact }),
    i18n.t('landingDesigners.contact.formBodyType', { type: params.typeLabel }),
    params.comment
      ? i18n.t('landingDesigners.contact.formBodyComment', { comment: params.comment })
      : '',
  ]
    .filter(Boolean)
    .join('\n')
}
